module.exports = __webpack_public_path__ + "img/top_popularity-two.e1f95d40.png";